import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "components/navbar";
import Sidebar from "components/sidebar";
import Footer from "components/footer/Footer";
import routes from "routes.js";
import OrderDetails from "views/admin/tables/single_order";
import SingleOrder from "views/admin/payment_admin/orderDetails";
import RunnerDetails from "views/admin/tables/runner_details";
import UserDetails from "views/admin/marketplace/view";
import UserDetailsRunner from "views/admin/runnerboys/view";
import CustomerUserDetails from "views/admin/user_profile/user_details";
import EditUser from "views/admin/marketplace/Edit_User";
import EditRunner from "views/admin/runnerboys/Edit_Runner";
export default function Admin(props) {
  const { ...rest } = props;
  const location = useLocation();
  const [open, setOpen] = React.useState(true);
  const [currentRoute, setCurrentRoute] = React.useState("Main Dashboard");

  React.useEffect(() => {
    window.addEventListener("resize", () =>
      window.innerWidth < 1200 ? setOpen(false) : setOpen(true)
    );
  }, []);
  React.useEffect(() => {
    getActiveRoute(routes);
  }, [location.pathname]);

  const getActiveRoute = (routes) => {
    let activeRoute = "Main Dashboard";
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(
          routes[i].layout + "/" + routes[i].path
        ) !== -1
      ) {
        setCurrentRoute(routes[i].name);
      }
    }
    return activeRoute;
  };
  const getActiveNavbar = (routes) => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
      ) {
        return routes[i].secondary;
      }
    }
    return activeNavbar;
  };
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };

  document.documentElement.dir = "ltr";
  return (
    <div className="flex h-full w-full">
      <Sidebar open={open} onClose={() => setOpen(false)} />
      {/* Navbar & Main Content */}
      <div className="h-full w-full bg-lightPrimary dark:!bg-navy-900">
        {/* Main Content */}
        <main
          className={`mx-2 sm:mx-3 md:mx-4 md:pr-2 h-full flex-none transition-all xl:ml-[288px] min-w-0 max-w-full`}
        >
          {/* Routes */}
          <div className="h-full">
            <Navbar
              onOpenSidenav={() => setOpen(true)}
              logoText={"Horizon UI Tailwind React"}
              brandText={currentRoute}
              secondary={getActiveNavbar(routes)}
              {...rest}
            />
            <div className="pt-2 sm:pt-4 mx-auto mb-auto h-full min-h-[84vh] px-2 sm:px-3 md:pr-2 min-w-0 max-w-full">
              <Routes>
                {getRoutes(routes)}
                <Route path="orders/:id" element={<OrderDetails />} />
                <Route path="/booking/:orderId" element={<SingleOrder />} />
                <Route path="/runner/:runnerId" element={<RunnerDetails />} />
                <Route path="/user_details/:id" element={<UserDetails />} />
                <Route path="user-details/:id" element={<CustomerUserDetails />} />
                <Route path="/runner_details/:id" element={<UserDetailsRunner />} />
                <Route path="/edit_user/:id" element={<EditUser />} />
                <Route path="/edit_runner/:id" element={<EditRunner />} />
                <Route
                  path="/"
                  element={<Navigate to="/admin/default" replace />}
                />
              </Routes>
            </div>
            <div className="p-3">
              <Footer />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
